import React from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import {setShowPopUp} from '../TransferOrganizationAccountSlice';
import BtnSubmit from '../../../Shared/Buttons/BtnSubmit';

const PricePlanDetailsPopUp = (props) => {
  return (
    <div>
      <p className='L_Title'>מידע נוסף על החבילה</p>

      {props.data.selectedPricePlan.plan_code_details_arr.plan_code_details.map((plan, i) => (
        <div className='section' key={i}>
          {plan.soc_business_detail_desc}
        </div>
      ))}
      <div className='btn_submit_container'>
        <BtnSubmit text='הבנתי,תודה!' onclick={() => props.setShowPopUp(false)} />
      </div>
    </div>
  );
};

PricePlanDetailsPopUp.propTypes = {};

const mapStateToProps = (state) => ({
  data: state.TransferOrganizationAccount,
});

const mapDispatchToProps = {setShowPopUp};

export default connect(mapStateToProps, mapDispatchToProps)(PricePlanDetailsPopUp);
